{
    "columns": [
      {
        "header_id": "vendorName",
        "header_label": "Vendor Name",
        "jsonpath": "vendorName",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "pplPurchaseId",
        "header_label": "PPL Purchase ID",
        "jsonpath": "pplPurchaseId",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "submissionDate",
        "header_label": "Submission Date",
        "jsonpath": "submissionDate",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "usedUnits",
        "header_label": "Spent Dollars",
        "jsonpath": "usedUnits",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      }
    ],
    "buttons": [],
    "apiDetails": "authPurchaseRequestsList.json",
    "pageName": "addAuthorizationsList",
    "orderByColumn": ["purchaseRequestLineDetailId"],
    "orderBy": ["desc"]
  }
  